import { createContext } from "react";
import { ITableContextValue, ITableState } from "./interfaces";

const TableContext = createContext({} as ITableContextValue);

const { Provider, Consumer } = TableContext;

const TABLE_INIT_STATE: ITableState = {
  filters: [],
  sorting: undefined,
  searchInput: "",
  page: 0,
  rowsPerPage: 25,
  columns: [],
  rawData: [],
  filterData: [],
  loading: false
};

export {
  Provider as TableProvider,
  Consumer as TableConsumer,
  TableContext,
  TABLE_INIT_STATE
};
